import React from 'react';
import { useStaticQuery, Link, graphql } from 'gatsby';

import { ReactComponent as Logo } from '../../assets/svg/logo.svg';

const isPartiallyActive = ({ isPartiallyCurrent }) => {
	return isPartiallyCurrent ? { className: 'current' } : {};
};

const PartialNavLink = (props) => (
	<Link getProps={isPartiallyActive} {...props} />
);

export default function NavBar() {
	const { site, i18NJson: i18n } = useStaticQuery(graphql`
		query {
			site {
				siteMetadata {
					title
				}
			}
			i18NJson {
				ui {
					homeBack
					about
					portfolio
					testimonials
					blog
					contact
				}
			}
		}
	`);

	return (
		<nav id="navbar" className="navbar navbar-fixed-top">
			<div className="topbar">
				<div className="container">
					<div className="navbar-header">
						<button
							type="button"
							className="navbar-toggle"
							data-toggle="collapse"
							data-target=".navbar-ex1-collapse"
						>
							<span className="sr-only">Menu</span>
							<span className="icon-bar"></span>
							<span className="icon-bar"></span>
							<span className="icon-bar"></span>
						</button>
						<Link
							to={'/'}
							className="navbar-brand"
							title={i18n.ui.homeBack}
						>
							<span className="sr-only">
								{site.siteMetadata.title}
							</span>
							<Logo />
						</Link>
					</div>

					<div className="collapse navbar-collapse navbar-ex1-collapse">
						<ul className="nav navbar-nav navbar-right">
							<li className="about">
								<PartialNavLink
									to={
										process.env.GATSBY_PAGES_ABOUT_SLUG ||
										'/about/'
									}
								>
									{i18n.ui.about}
								</PartialNavLink>
							</li>
							<li className="portfolio">
								<PartialNavLink
									to={
										process.env
											.GATSBY_PAGES_PORTFOLIO_SLUG ||
										'/portfolio/'
									}
								>
									{i18n.ui.portfolio}
								</PartialNavLink>
							</li>
							<li className="testimonials">
								<PartialNavLink
									to={
										process.env
											.GATSBY_PAGES_TESTIMONIALS_SLUG ||
										'/testimonials/'
									}
								>
									{i18n.ui.testimonials}
								</PartialNavLink>
							</li>
							<li className="blog">
								<PartialNavLink
									to={
										process.env.GATSBY_PAGES_BLOG_SLUG ||
										'/blog/'
									}
								>
									{i18n.ui.blog}
								</PartialNavLink>
							</li>
							<li className="contact">
								<PartialNavLink
									to={
										process.env.GATSBY_PAGES_CONTACT_SLUG ||
										'/contact/'
									}
								>
									{i18n.ui.contact}
								</PartialNavLink>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</nav>
	);
}
